import { Injectable } from '@angular/core';
import { createStoreValidator } from '@core/helpers/create-validator.helper';
import { Store } from '@ngrx/store';
import { isAfter, isBefore, isEqual } from 'date-fns';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import * as _ from 'lodash';
import { Utilities } from '@core/helpers/utilities';

@Injectable({ providedIn: 'root' })
export class SezIIAccertamentoStoreValidators {
  constructor(private store: Store<Revisione53State>) {}

  defaultAccertamentoValidator = (fieldName: string) =>
    createStoreValidator(this.store, (myVerbale: MyVerbale) => {
      const fieldValue = myVerbale.my_SezioneII__Accertamento[fieldName];
      const my_StatoVerbale = myVerbale.my_StatoVerbale;
      const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
      const my_CkProposte =
        myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;

      let error = null;

      if (
        !fieldValue &&
        my_StatoVerbale === '1' &&
        my_StatoAccertamento === '1' &&
        my_CkProposte === '3'
      ) {
        error = {
          my_DenominazEnteII: {
            status: 'Campo obbligatorio',
            message: 'Campo obbligatorio',
          },
        };
      }

      return error;
    });

  my_SezEnteII = createStoreValidator(this.store, (myVerbale) => {
    const my_SezEnteII = myVerbale.my_SezioneII__Accertamento.my_SezEnteII;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_CkMutualPrevII =
      myVerbale.my_SezioneII__Accertamento.my_CkMutualPrevII;

    let error = null;

    if (
      my_SezEnteII === '' &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      my_CkMutualPrevII != '3'
    ) {
      error = {
        my_PosizAlboEntiII: {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio'
        },
      };
    }

    return error;
  });

  my_MatricolaII = createStoreValidator(this.store, (myVerbale) => {
    const my_ElAderentiAII =
      myVerbale.my_SezioneII__Accertamento.my_AderentiAII.my_ElAderentiAII;
    const my_CkTipoAccertamento =
      myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;

    let error = null;

    if (
      my_ElAderentiAII.length === 0 &&
      my_CkTipoAccertamento === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3'
    ) {
      error = {
        my_MatricolaII: {
          status: 'Campo obbligatorio',
          message: 'Attenzione, non sono presenti adesioni',
        },
      };
    }

    return error;
  });

  my_DataCompilazII = createStoreValidator(this.store, (myVerbale) => {
    const my_DataCompilazII =
      myVerbale.my_SezioneII__Accertamento.my_DataCompilazII;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_DataCompilaz =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_DataCompilaz;

    let error = null;

    const afterDate = isAfter(
      new Date(my_DataCompilazII),
      new Date('2079-06-06')
    );

    const beforeDataCompilaz = isBefore(
      new Date(my_DataCompilazII),
      new Date(my_DataCompilaz)
    );

    if (
      !my_DataCompilazII &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3'
    ) {
      error = {
        my_DataCompilazII: {
          status: 'Il campo deve essere inserito obbligatoriamente.',
          message: 'Campo obbligatorio'
        },
      };
    } else if (afterDate) {
      error = {
        my_DataCompilazII: {
          status: "Data non corretta",
          message: 'Data non consentita',
        },
      };
    } else if (
      my_DataCompilazII &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      beforeDataCompilaz
    ) {
      error = {
        my_DataCompilazII: {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio'
        },
      };
    }

    return error;
  });

  my_CkProposteII = createStoreValidator(this.store, (myVerbale: MyVerbale) => {
    const my_CkProposteII =
      myVerbale.my_SezioneII__Accertamento.my_CkProposteII;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_CkTipoAccertamento =
      myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;
    const my_CkAltriFattiProvv =
      myVerbale.my_SezioneII__Accertamento.my_CkAltriFattiProvv;
    const my_DataCompilazII =
      myVerbale.my_SezioneII__Accertamento.my_DataCompilazII;
    const my_ElSanzioniAccessorie =
      myVerbale.my_SezioneII__Accertamento.my_SanzioniAccessorie
        .my_ElSanzioniAccessorie;

    let error = null;

    let counterSanzioni: number = 0;

    const afterOrEqual =
      isAfter(new Date(my_DataCompilazII), new Date('2018-09-01')) ||
      isEqual(new Date(my_DataCompilazII), new Date('2018-09-01'));

    (Array.isArray(my_ElSanzioniAccessorie) ? my_ElSanzioniAccessorie : []).forEach((e) => {
      if (
        e.my_idEsitoRevisione === '9001' &&
        e.my_CkSanzioniAccessorie === '1'
      ) {
        counterSanzioni++;
      }
    });

    if (my_CkProposteII === '2' && counterSanzioni < 1) {
      error = {
        my_CkProposteII: {
          status: 'Campo obbligatorio',
          message: 'Indicare una sanzione accessoria',
        },
      };
    } else if (
      my_CkProposteII === '' &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3'
    ) {
      error = {
        my_CkProposteII: {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio'
        },
      };
    } else if (
      my_CkProposteII != '5' &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      my_CkTipoAccertamento === '3'
    ) {
      error = {
        my_CkProposteII: {
          status: 'Incongruenza con la tipologia di Accertamento',
          message:
            'Non si possono proporre nè accertati nè provvedimenti in un mancato accertamento',
        },
      };
    } else if (
      my_CkProposteII === '5' &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      my_CkTipoAccertamento != '3'
    ) {
      error = {
        my_CkProposteII: {
          status: 'Inconguenza con la tipologia di Accertamento',
          message: '',
        },
      };
    } else if (
      my_CkProposteII === '1' &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      my_CkAltriFattiProvv === '1' &&
      my_CkTipoAccertamento != '3' &&
      afterOrEqual
    ) {
      error = {
        my_CkProposteII: {
          status: 'Incongruenza con quanto specificato al punto 66',
          message: 'Incongruenza con quanto specificato al punto 66',
        },
      };
    } else if (
      my_CkProposteII === '1' &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkTipoAccertamento != '1' &&
      my_CkProposte === '3'
    ) {
      error = {
        my_CkProposteII: {
          status: 'Inconguenza con la tipologia di Accertamento',
          message: 'Inconguenza con la tipologia di Accertamento',
        },
      };
    }

    return error;
  });

  my_CkProvvedimendoDiII = createStoreValidator(this.store, (myVerbale) => {
    const my_CkProvvedimendoDiII =
      myVerbale.my_SezioneII__Accertamento.my_CkProvvedimendoDiII;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_CkProposteII =
      myVerbale.my_SezioneII__Accertamento.my_CkProposteII;
    const my_ElSanzioniAccessorie =
      myVerbale.my_SezioneII__Accertamento.my_SanzioniAccessorie
        .my_ElSanzioniAccessorie;

    let error = null;

    let counterSanzioni: number = 0;

    (Array.isArray(my_ElSanzioniAccessorie) ? my_ElSanzioniAccessorie : []).forEach((e) => {
      if (
        e.my_idEsitoRevisione === '9001' &&
        e.my_CkSanzioniAccessorie === '1'
      ) {
        counterSanzioni++;
      }
    });

    if (
      my_CkProvvedimendoDiII === '' &&
      my_StatoVerbale === '1' &&
      my_CkProposte === '3' &&
      my_CkProposteII === '2'
    ) {
      error = {
        my_CkProvvedimendoDiII: {
          status: 'Campo obbligatorio',
          message: 'Una scelta deve essere fatta obbligatoriamente',
        },
      };
    } else if (
      my_CkProvvedimendoDiII === '8' &&
      my_StatoVerbale === '1' &&
      my_CkProposte === '3' &&
      my_CkProposteII === '2' &&
      counterSanzioni > 0
    ) {
      error = {
        my_CkProvvedimendoDiII: {
          status: 'Eliminare il relativo provvedimento accessorio',
          message: 'Eliminare il relativo provvedimento accessorio'
        },
      };
    }
    return error;
  });

  my_CkNominaLiqII = createStoreValidator(this.store, (myVerbale) => {
    const my_CkNominaLiqII =
      myVerbale.my_SezioneII__Accertamento.my_CkNominaLiqII;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_CkProposteII =
      myVerbale.my_SezioneII__Accertamento.my_CkProposteII;
    const my_CkProvvedimendoDiII =
      myVerbale.my_SezioneII__Accertamento.my_CkProvvedimendoDiII;

    let error = null;

    if (
      my_CkNominaLiqII === '' &&
      my_StatoVerbale === '1' &&
      my_CkProvvedimendoDiII === '3' &&
      my_CkProposte === '3' &&
      my_CkProposteII === '2'
    ) {
      error = {
        my_CkNominaLiqII: {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio',
        },
      };
    } else if (
      my_CkNominaLiqII === '' &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      my_CkProposteII === '5' &&
      my_CkProvvedimendoDiII === '8'
    ) {
      error = {
        my_CkProvvedimendoDiII: {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio',
        },
      };
    }
    return error;
  });

  my_EventAltreNotiz = createStoreValidator(this.store, (myVerbale) => {
    const my_EventAltreNotiz =
      myVerbale.my_SezioneII__Accertamento.my_EventAltreNotiz;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_CkAltriFattiProvv =
      myVerbale.my_SezioneII__Accertamento.my_CkAltriFattiProvv;
    const my_CkTipoAccertamento =
      myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;

    let error = null;

    if (
      my_EventAltreNotiz === '' &&
      my_CkTipoAccertamento === '1' &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      my_CkAltriFattiProvv === '1'
    ) {
      error = {
        my_EventAltreNotiz: {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio'
        },
      };
    }

    return error;
  });

  defaultValidatorConTipoAccertamento = (fieldName: string): AsyncValidatorFn =>
    createStoreValidator(this.store, (myVerbale) => {
      const fieldValue = myVerbale.my_SezioneII__Accertamento[fieldName];
      const my_StatoVerbale = myVerbale.my_StatoVerbale;
      const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
      const my_CkProposte =
        myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
      const my_CkTipoAccertamento =
        myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;

      let error = null;

      if (
        !fieldValue &&
        my_CkTipoAccertamento === '1' &&
        my_StatoVerbale === '1' &&
        my_StatoAccertamento === '1' &&
        my_CkProposte === '3'
      ) {
        error = {};
        error[fieldName] = {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio'
        };
      }

      return error;
    });

  my_SpecConoscSoci = createStoreValidator(this.store, (myVerbale) => {
    const my_SpecConoscSoci =
      myVerbale.my_SezioneII__Accertamento.my_SpecConoscSoci;
    const my_CkConoscSoci =
      myVerbale.my_SezioneII__Accertamento.my_CkConoscSoci;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_CkTipoAccertamento =
      myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;

    let error = null;

    if (
      my_SpecConoscSoci === '' &&
      my_CkTipoAccertamento === '1' &&
      my_CkConoscSoci === '0' &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3'
    ) {
      error = {
        my_SpecConoscSoci: {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio'
        },
      };
    }

    return error;
  });

  my_CommRisultAccert = createStoreValidator(this.store, (myVerbale) => {
    const my_ElRisultanzeAccert =
      myVerbale.my_SezioneII__Accertamento.my_RisultanzeAccert
        .my_ElRisultanzeAccert;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_CkTipoAccertamento =
      myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;

    let error = null;

    my_ElRisultanzeAccert.forEach((e) => {
      if (
        e.my_CommRisultAccert === '' &&
        my_StatoAccertamento === '1' &&
        my_StatoVerbale === '1' &&
        my_CkProposte === '3' &&
        my_CkTipoAccertamento != '3'
      ) {
        error = {
          my_CommRisultAccert: {
            status: 'Campo obbligatorio',
            message: 'Campo obbligatorio'
          },
        };
      }
    });

    return error;
  });

  my_CkTipoAccertamento = createStoreValidator(this.store, (myVerbale) => {
    const my_CkTipoAccertamento =
      myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_DataDiffidaAContatto = myVerbale.my_DataDiffidaAContatto;

    let error = null;

    if (
      my_CkTipoAccertamento === '2' &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      my_DataDiffidaAContatto === ''
    ) {
      error = {
        my_CkTipoAccertamento: {
          status: "Attenzione: si deve diffidare il legale rappresentante a prendere contatto per effettuare l'accertamento",
          message:
            "Attenzione: si deve diffidare il legale rappresentante a prendere contatto per effettuare l'accertamento",
        },
      };
    }

    return error;
  });

  my_AllegatoAltroSpecif = createStoreValidator(this.store, (myVerbale) => {
    const my_AllegatoAltroSpecif =
      myVerbale.my_SezioneII__Accertamento.my_AllegatoAltroSpecif;
    const my_CkAllegatoAltro =
      myVerbale.my_SezioneII__Accertamento.my_CkAllegatoAltro;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_CkTipoAccertamento =
      myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;

    let error = null;

    if (
      my_AllegatoAltroSpecif === '' &&
      my_CkAllegatoAltro &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      my_CkTipoAccertamento === '1'
    ) {
      error = {
        my_GiudizioConclusivoII: {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio'
        },
      };
    }

    return error;
  });

  my_RilevaPressoEnte = createStoreValidator(this.store, (myVerbale) => {
    const my_RilevaPressoEnte =
      myVerbale.my_SezioneII__Accertamento.my_RilevaPressoEnte;
    const my_Ck_SiRecaPressoEnte =
      myVerbale.my_SezioneII__Accertamento.my_Ck_SiRecaPressoEnte;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_CkTipoAccertamento =
      myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;

    let error = null;

    if (
      my_RilevaPressoEnte === '' &&
      my_Ck_SiRecaPressoEnte === '1' &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      my_CkTipoAccertamento === '3'
    ) {
      error = {
        my_RilevaPressoEnte: {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio'
        },
      };
    }

    return error;
  });

  my_NumeroNotaLetteraIncarico = createStoreValidator(
    this.store,
    (myVerbale) => {
      const my_NumeroNotaLetteraIncarico =
        myVerbale.my_SezioneII__Accertamento.my_NumeroNotaLetteraIncarico;
      const my_StatoVerbale = myVerbale.my_StatoVerbale;
      const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
      const my_CkProposte =
        myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
      const my_CkTipoAccertamento =
        myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;

      let error = null;

      if (
        my_NumeroNotaLetteraIncarico === '' &&
        my_StatoVerbale === '1' &&
        my_StatoAccertamento === '1' &&
        my_CkProposte === '3' &&
        my_CkTipoAccertamento === '3'
      ) {
        error = {
          my_NumeroNotaLetteraIncarico: {
            status: 'Campo obbligatorio',        
            message: 'Campo obbligatorio'
          },
        };
      }

      return error;
    }
  );

  my_DataLetteraIncarico = createStoreValidator(this.store, (myVerbale) => {
    const my_DataLetteraIncarico =
      myVerbale.my_SezioneII__Accertamento.my_DataLetteraIncarico;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_CkTipoAccertamento =
      myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;

    let error = null;

    if (
      my_DataLetteraIncarico === '' &&
      my_StatoVerbale === '1' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      my_CkTipoAccertamento === '3'
    ) {
      error = {
        my_DataLetteraIncarico: {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio'
        },
      };
    }

    return error;
  });

  my_SchedaPropostaGestioneCommIIValidator = (
    fieldName: string
  ): AsyncValidatorFn =>
    createStoreValidator(
      this.store,
      (myVerbale: MyVerbale, control: AbstractControl): AsyncValidatorFn => {
        let error = null;
        if (
          !control.value &&
          _.get(
            myVerbale,
            'my_SezioneII__Accertamento.my_CkProvvedimendoDiII'
          ) === '2'
        ) {
          error = {};
          error[fieldName] = {
            status: 'Campo obbligatorio',
            message: 'Campo obbligatorio',
          };
        }
        return error;
      }
    );

  my_descArt2545RicII = createStoreValidator(
    this.store,
    (myVerbale: MyVerbale, control: AbstractControl): AsyncValidatorFn => {
      let error = null;
      const my_CkProvvedimendoDiII = _.get(
        myVerbale,
        'my_SezioneII__Accertamento.my_CkProvvedimendoDiII'
      );
      if (!control.value && my_CkProvvedimendoDiII === '3') {
        const my_ckImpossRaggScopoII = _.get(
          myVerbale,
          'my_SezioneII__Accertamento.my_SchedaPropostaScioglimentoII.my_ckImpossRaggScopoII'
        );
        const my_ckNonPersegScMutuaII = _.get(
          myVerbale,
          'my_SezioneII__Accertamento.my_SchedaPropostaScioglimentoII.my_ckNonPersegScMutuaII'
        );
        const my_ckNoDepBil2AnniII = _.get(
          myVerbale,
          'my_SezioneII__Accertamento.my_SchedaPropostaScioglimentoII.my_ckNoDepBil2AnniII'
        );
        const my_ckNoAttiGest2AnniII = _.get(
          myVerbale,
          'my_SezioneII__Accertamento.my_SchedaPropostaScioglimentoII.my_ckNoAttiGest2AnniII'
        );

        if (
          my_ckImpossRaggScopoII ||
          my_ckNonPersegScMutuaII ||
          my_ckNoDepBil2AnniII ||
          my_ckNoAttiGest2AnniII
        ) {
          error = {
            my_descArt2545RicII: {
              status: 'Campo obbligatorio',
              message: 'Campo obbligatorio',
            },
          };
        }
      }
      return error;
    }
  );

  propostaScioglValidator = (fieldName: string): AsyncValidatorFn =>
    createStoreValidator(
      this.store,
      (myVerbale: MyVerbale, control: AbstractControl) => {
        let error = null;
        if (!control.value) {
          const my_CkProvvedimendoDiII = _.get(
            myVerbale,
            'my_SezioneII__Accertamento.my_CkProvvedimendoDiII'
          );
          if (my_CkProvvedimendoDiII === '3') {
            error = {};
            error[fieldName] = {
              status: 'Campo obligatorio',
              message: 'Campo obligatorio',
            };
          }
        }
        return error;
      }
    );

  my_CkSanzioniAccessorieRilevazione2 = createStoreValidator(
    this.store,
    (myVerbale: MyVerbale, control: AbstractControl): AsyncValidatorFn => {
      const my_CkProposte =
        myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
      const my_CkProposteII =
        myVerbale.my_SezioneII__Accertamento.my_CkProposteII;
      const my_StatoVerbale = myVerbale.my_StatoVerbale;
      const my_StatoAccertamento = myVerbale.my_StatoAccertamento;

      let error: any = null;

      if (control.value === '1' && my_CkProposteII === '1') {
        error = {
          my_CkSanzioniAccessorie: {
            status: 'Errore: incoerenza nelle risultanze',
            message: 'Errore: incoerenza nelle risultanze',
          },
        };
      } else if (
        control.value === '1' &&
        my_CkProposteII === '1' &&
        my_StatoVerbale === '1' &&
        my_StatoAccertamento === '1' &&
        my_CkProposte === '3'
      ) {
        error = {
          my_CkSanzioniAccessorie: {
            status: 'Errore: incoerenza nelle risultanze',
            message:
              "Le sanzioni accessorie accompagnano una proposta di provvedimento e non il rilascio dell'attestato",
          },
        };
      }
      return error;
    }
  );

  sostiuzioneLiquidatoreValidator = (fieldName: string): AsyncValidatorFn => {
    return createStoreValidator(
      this.store,
      (myVerbale: MyVerbale, control: AbstractControl) => {
        let error = null;
        const my_CkProvvedimendoDiII = _.get(
          myVerbale,
          'my_SezioneII__Accertamento.my_CkProvvedimendoDiII'
        );
        if (!control.value && ['4', '9'].includes(my_CkProvvedimendoDiII)) {
          error = {};
          error[fieldName] = {
            status: 'Campo obbligatorio',
            message: 'Campo obbligatorio',
          };
        }
        return error;
      }
    );
  };

  my_CkSanzioniAccessorieRilevazione = createStoreValidator(
    this.store,
    (myVerbale: MyVerbale) => {
      const my_ElSanzioniAccessorie =
        myVerbale.my_SezioneII__Accertamento.my_SanzioniAccessorie
          .my_ElSanzioniAccessorie;
      const my_CkProposte =
        myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;

      let error = null;

      my_ElSanzioniAccessorie.forEach((e) => {
        if (e.my_CkSanzioniAccessorie === '1' && my_CkProposte != '2') {
          error = {
            my_CkSanzioniAccessorie: {
              status: "Scelta non consentita",
              message: 'Scelta non consentita. Contattare il capo area',
            },
          };
        }
      });

      return error;
    }
  );

  my_LuogoAccertamento = createStoreValidator(this.store, (myVerbale) => {
    const my_LuogoAccertamento =
      myVerbale.my_SezioneII__Accertamento.my_LuogoAccertamento;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_CkTipoAccertamento =
      myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;

    let error = null;

    if (
      my_LuogoAccertamento === '---' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      my_CkTipoAccertamento === '1'
    ) {
      error = {
        my_LuogoAccertamento: {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio',
        },
      };
    }

    return error;
  });

  my_SpecificaLuogoAccertamento = createStoreValidator(
    this.store,
    (myVerbale) => {
      const my_SpecificaLuogoAccertamento =
        myVerbale.my_SezioneII__Accertamento.my_SpecificaLuogoAccertamento;
      const my_LuogoAccertamento =
        myVerbale.my_SezioneII__Accertamento.my_LuogoAccertamento;
      const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
      const my_StatoVerbale = myVerbale.my_StatoVerbale;
      const my_CkProposte =
        myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
      const my_CkTipoAccertamento =
        myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;

      let error = null;

      if (
        my_SpecificaLuogoAccertamento === '' &&
        my_LuogoAccertamento === 'Altro luogo ...' &&
        my_StatoAccertamento === '1' &&
        my_CkProposte === '3' &&
        my_CkTipoAccertamento === '1' &&
        my_StatoVerbale === '1'
      ) {
        error = {
          my_LuogoAccertamento: {
            status: 'Campo obbligatorio',
            message: 'Campo obbligatorio',
          },
        };
      }

      return error;
    }
  );

  my_AltraPECII = createStoreValidator(this.store, (myVerbale) => {
    const my_AltraPECII = myVerbale.my_SezioneII__Accertamento.my_AltraPECII;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_PECcciII = myVerbale.my_SezioneII__Accertamento.my_PECcciII;

    let error = null;

    if (
      my_AltraPECII === '' &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      my_StatoVerbale === '1' &&
      my_PECcciII === ''
    ) {
      error = {
        my_LuogoAccertamento: {
          status: 'Rilevare la PEC della cooperativa',
          message: 'Rilevare la PEC della cooperativa',
        },
      };
    }

    return error;
  });

  my_EsitoPEC_LR = createStoreValidator(this.store, (myVerbale) => {
    const my_EsitoPEC_LR = myVerbale.my_SezioneII__Accertamento.my_EsitoPEC_LR;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_Ck_InviataPEC_LR =
      myVerbale.my_SezioneII__Accertamento.my_Ck_InviataPEC_LR;

    let error = null;

    if (
      Utilities.isNullOrEmptyString(my_EsitoPEC_LR) &&
      my_StatoAccertamento === '1' &&
      my_Ck_InviataPEC_LR === '1' &&
      my_StatoVerbale === '1'
    ) {
      error = {
        my_EsitoPEC_LR: {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio',
        },
      };
    }

    return error;
  });

  contrattoDefaultValidator = (fieldName: string) =>
    createStoreValidator(
      this.store,
      (myVerbale: MyVerbale, control: AbstractControl) => {
        const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
        const my_StatoVerbale = myVerbale.my_StatoVerbale;
        const my_CkProposte =
          myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
        const my_CkTipoAccertamento =
          myVerbale.my_SezioneII__Accertamento.my_CkTipoAccertamento;

        let error = null;

        if (
          (control?.value === '' ||
            control?.value === '0' ||
            control?.value === false ||
            _.isNil(control?.value)) &&
          my_StatoAccertamento === '1' &&
          my_CkProposte === '3' &&
          my_StatoVerbale === '1' &&
          my_CkTipoAccertamento === '2'
        ) {
          error = {};
          error[fieldName] = {
            status: 'Campo obbligatorio',
            message: 'Campo obbligatorio',
          };
        }

        return error;
      }
    );

  my_EsitoLettera = createStoreValidator(this.store, (myVerbale) => {
    const my_EsitoLettera =
      myVerbale.my_SezioneII__Accertamento.my_EsitoLettera;
    const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
    const my_StatoVerbale = myVerbale.my_StatoVerbale;
    const my_CkProposte =
      myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
    const my_CkInviataLettera =
      myVerbale.my_SezioneII__Accertamento.my_CkInviataLettera;

    let error = null;

    if (
      Utilities.isNullOrEmptyString(my_EsitoLettera) &&
      my_StatoAccertamento === '1' &&
      my_CkProposte === '3' &&
      my_StatoVerbale === '1' &&
      my_CkInviataLettera === '1'
    ) {
      error = {
        my_EsitoLettera: {
          status: 'Campo obbligatorio',
          message: 'Campo obbligatorio',
        },
      };
    }

    return error;
  });
}
